import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import NavBarDirective from './directives/NavBarDirective';
import NavBarItems from './directives/NavBarItems';
import mediaSidebarConfig from 'portal/config/media-sidebar-config';
import TransactionWizardTitleGateway from './components/transactionWizardTitle';
import WizardSidebarAdditionalGateway from './directives/wizardSidebarAdditional';
import ConfirmationBackButtonGateway from './components/confirmationBackButton';
import _ from 'lodash';

import 'edge/platform/widgets/pagestructure/module';
import 'edge/gateway/app';
import 'edge/faq/app';
import 'conditional?if=gatewayclaims&equals=true!edge/fnol/app';
import 'conditional?if=gatewayclaims&equals=true!edge/claim/app';
import 'edge/billing/app';
import 'conditional?if=gatewayquoteandbind&equals=true!edge/quoteandbind/app';
import 'edge/endorsement/app';
import 'gw-portals-policytransaction-angular';
import 'edge/policy/app';
import 'edge/platform/widgets/icon/module';
import 'conditional?if=journey&equals=true!edge/journey/app';
import SetVersionDocumentTitle from 'gw-portals-platform-angular/versionName/SetVersionDocumentTitle';
import 'styles-portal/sass/modules.scss';
import 'gw-portals-renewal-angular';
import 'gw-portals-policydiff-angular';
import 'edge/platform/widgets/footer/module';
import 'edge/platform/uimetadata/module';
import 'gw-portals-driven-ui-angular/module';
import '@uirouter/angularjs/lib/legacy/stateEvents.js';
import 'conditional?if=serviceRequests&equals=true!edge/servicerequest/app'; // PSA

const modules = [
    'edge.platform.widgets.pagestructure',
    'edge.platform.widgets.icon',
    'edge.gateway.app',
    'edge.billing.app',
    'edge.faq.app',
    'ui.router',
    'edge.endorsement.app',
    'edge.transaction.app',
    'edge.policy.app',
    'edge.renewal.app',
    'edge.policydiff.app',
    'edge.platform.charts',
    'edge.platform.widgets.footer',
    'edge.platform.uimetadata',
    'edge.platform.metadataDrivenUI',
    'ui.router.state.events'
];

const applicationFeatures = ApplicationFeatures.getAllFeatures();
if (applicationFeatures.gatewayclaims === 'true') {
    modules.push('edge.fnol.app');
    modules.push('edge.claim.app');
}
if (applicationFeatures.gatewayquoteandbind === 'true') {
    modules.push('edge.quoteandbind.app');
}
if (applicationFeatures.journey === 'true') {
    modules.push('edge.journey.app');
}
if (applicationFeatures.serviceRequests === 'true') { // PSA
    modules.push('edge.servicerequest.app');
}
const SUPERCEDED_TRANSITION_REJECTION = 2;

export default angular.module('portal.app', modules)
    .factory('NavBarItems', NavBarItems)
    .directive('gwPortalNavBar', NavBarDirective)
    .factory('MEDIA_SIDEBAR_CONFIGURATION', mediaSidebarConfig)

    .config(['FaqServiceProvider', 'FAQ_CONFIG', 'USER_INFO', '$provide', (FaqServiceProvider, FAQ_CONFIG, USER_INFO) => {
        FaqServiceProvider.setSections(FAQ_CONFIG.agent.sections); // PSA: always 'producer' like, never 'underwriter'
        /* PSA
        if (USER_INFO().userType === 'producer') {
            FaqServiceProvider.setSections(FAQ_CONFIG.agent.sections);
        } else {
            FaqServiceProvider.setSections(FAQ_CONFIG.underwriter.sections);
        }
        */
    }])

    .config(['$provide', ($provide) => {
        // Override the default gw-transaction-wizard-title
        $provide.decorator('gwTransactionWizardTitleDirective', ['$delegate',
            ($delegate) => [_.extend($delegate[0], TransactionWizardTitleGateway)]
        ]);
    }])

    .config(['$provide', ($provide) => {
        // Override the default gw-wizard-sidebar-additional
        $provide.decorator('gwWizardSidebarAdditionalDirective', ['$delegate',
            ($delegate) => [_.extend($delegate[0], WizardSidebarAdditionalGateway)]
        ]);
    }])

    .config(['$provide', ($provide) => {
        // Override the default gw-fnol-confirmation-back-button
        $provide.decorator('gwFnolConfirmationBackButtonDirective', ['$delegate',
            ($delegate) => [_.extend($delegate[0], ConfirmationBackButtonGateway)]
        ]);
    }])

    .config(['$locationProvider', ($locationProvider) => {
        $locationProvider.hashPrefix('');
    }])

    /**
     * Overrides printing a console error whenever a promise rejected and there’s no .catch block to handle that failure.
     * 
     * @param {Object} $qProvider the promise provider
     */
    // PSA .config(['$qProvider', ($qProvider) => {
    // PSA    $qProvider.errorOnUnhandledRejections(false);
    // PSA }])

    .run(['$translate', '$state', ($translate, $state) => {
        SetVersionDocumentTitle({
            $translate,
            // "portal.app.versionName.title[.${VERSION}]" l10n ID (with a version, if available for the app) will be used
            translationIdBase: 'portal.app.versionName.title'
        });
        const errorHandler = $state.defaultErrorHandler();
        $state.defaultErrorHandler((error) => {
            // This is a naive implementation to silence the default error handler when there is a superceded transaction
            if (error.type === SUPERCEDED_TRANSITION_REJECTION) {
                console.warn(error);
            } else {
                errorHandler(error);
            }         
        });
    }]);


